import styled from "styled-components"
import { ImageWithLinkOrNot } from "./../../common/ImageWithLinkOrNot"

export const Wrapper = styled.div`
  width: 90%;
  max-width: 1300px;
  margin: auto;
`

export const Heading = styled.div`
  width: 100%;
  display: flex;
  margin-top: 1em;
  margin-bottom: 4em;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-around;
`

export const Box = styled.div`
  font-size: 1.2em;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  max-width: 50%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  &:first-child {
    width: 60%;
  }
  &:last-child {
    width: 40%;
  }
  justify-content: center;
  text-align: justify;
  align-content: center;
`

export const EnsembleImage = styled.div`
  position: relative;
`

export const Logo = styled(ImageWithLinkOrNot)`
  width: auto;
  height: 100px;
  align-items: end;
  object-fit: cover;
  position: absolute;
  bottom: 10%;
  right: 0%;
  z-index: 2;
`

export const Image = styled(ImageWithLinkOrNot)`
  overflow: auto;
  position: relative;
  height: 420px;
  width: 580px;
  overflow: hidden;
  object-fit: cover;
`

export const ImageList = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2px;
  max-width: 100%;
  height: 350px;
  flex-wrap: nowrap;
  box-sizing: content-box;
`

export const ImageContainer = styled(ImageWithLinkOrNot)`
  margin: 2px;
  overflow: auto;
  max-height: 100%;
  object-fit: cover;
`
export const WrapperMobile = styled.div``

export const HeadingMobile = styled.div`
  width: 97%;
  margin: auto;
`

export const BoxMobile = styled.div`
  width: 90%;
  margin: auto;
  display: flex;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  flex-direction: column;
  align-items: center;
  text-align: justify;
  align-content: center;
  justify-content: center;
`

export const LogoMobile = styled(ImageWithLinkOrNot)`
  width: auto;
  height: 70px;
  align-items: end;
  position absolute;
  bottom: 10%;
  right: -15%;
  z-index: 2;
`

export const ImageMobile = styled.img`
  margin: 10px;
  object-fit: cover;
`
export const ImageListMobile = styled.div`
  width: 100%;
`
export const ImageContainerMobile = styled.img`
  width: 100%;
  height: 300px;
  margin-top: 10px;
  object-fit: cover;
  margin: 5px;
`
